/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M9.166 4.276L7 6.441 4.834 4.276l-.557.558 2.165 2.165-2.165 2.166.557.558L7 7.558l2.166 2.165.557-.558L7.558 7l2.165-2.165-.557-.558z" _fill="#2E48DA"/><path pid="1" d="M7 .333A6.674 6.674 0 00.333 7 6.674 6.674 0 007 13.667 6.674 6.674 0 0013.667 7 6.674 6.674 0 007 .333zm0 12.545A5.884 5.884 0 011.123 7 5.884 5.884 0 017 1.122 5.884 5.884 0 0112.878 7 5.885 5.885 0 017 12.878z" _fill="#2E48DA"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/delete.js